import React from 'react';

const AdLabelPlaceholder = () => (
  <div className="placeholder-info-label">
    <div className="placeholder-row placeholder-info-label__img animation" />
    <div className="placeholder-info-label__info">
      <div className="placeholder-row placeholder-info-label__info--title animation" />
      <div className="placeholder-row placeholder-info-label__info--title animation" />
      <div className="placeholder-row placeholder-info-label__info--views animation" />
      <div className="placeholder-row placeholder-info-label__info--metro animation" />
    </div>
    <div className="placeholder-row placeholder-info-label__info--descr animation" />
    <div className="placeholder-row placeholder-info-label__info--descr animation" />
    <div className="placeholder-row placeholder-info-label__info--descr animation" />
    <div className="placeholder-row placeholder-info-label__info--descr animation" />
  </div>
);

export default AdLabelPlaceholder;
